module.exports = __webpack_public_path__ + "img/titanium.fc4f8354.svg";